import { OrgRegistrationStatus } from '@dap/memberadmin/types';
import { Palette } from '@mui/material/styles';

export function getOrgRegistrationStatusChipColors(
  status: OrgRegistrationStatus,
  palette: Palette
): string | undefined {
  switch (status) {
    case OrgRegistrationStatus.ACTIVE:
    case OrgRegistrationStatus.NOT_APPLICABLE:
    case OrgRegistrationStatus.UNKNOWN:
      return undefined;
    case OrgRegistrationStatus.LIQUIDATING:
      return palette.warning.light;
    case OrgRegistrationStatus.BANKRUPT:
    case OrgRegistrationStatus.CEASED:
      return palette.warning.main;
  }
}
